<template>
	<div>
		<ai-agent-field-configurator
			v-if="featureEnabled('ai_tools')"
			:configuration="configuration"
			:field-name="fieldName"
			:context-options="contextOptions"
			:trigger-options="triggerOptions"
			:ai-agent-options="aiAgentOptions"
		></ai-agent-field-configurator>
		<feature-disabled-alert v-else feature="ai_tools" />
	</div>
</template>

<script>
import AIAgentFieldConfigurator from '@/lib/components/Fields/AIAgentFieldConfigurator.vue';
import langMixin from '@/lib/components/Translations/mixins/lang-mixin';
import { featureEnabled } from '@/services/global/features.interface';
import FeatureDisabledAlert from '@/lib/components/Fields/FeatureDisabledAlert.vue';

export default {
	mixins: [langMixin],
	components: { FeatureDisabledAlert, 'ai-agent-field-configurator': AIAgentFieldConfigurator },
	name: 'AiFieldConfiguratorWrapper',
	props: {
		fieldName: {
			type: String,
			default: 'configuration',
		},
		configuration: {
			type: Object,
			required: true,
		},
		contextOptions: {
			type: Array,
			required: true,
		},
		triggerOptions: {
			type: Array,
			required: true,
		},
		aiAgentOptions: {
			type: Array,
			required: true,
		},
	},
	methods: {
		featureEnabled,
	},
};
</script>

<style lang="scss" scoped>
.alert-info {
	margin-bottom: 15px;
}
</style>
